import { Divider, Typography } from '@mui/material';

import {
  AddYourDocumentsDependentBoxStyled,
  AddYourDocumentsPaperStyled,
  DocumentRequestProfileStyled,
} from './AddYourDocumentsCardStyled';
import { FamilyDrawerDisplayPicture } from '../../Family/FamilyDetailsPage/FamilyDrawerDisplayPicture';
import { AddDependentIQCardDetails } from './AddDependentIQCardDetails';
import { DisplayNoAvatarIcon } from 'enrollment/features/Shared/DisplayProfilePicture/DisplayAvatarIconList';
import { DocRequestDetails } from '.';
import { RequestedDocuments } from './RequestedDocuments';
import { UploadedDocuments } from './UploadedDocuments';

interface AddYourDocumentsCardType {
  saveAvatarName: string;
  saveAvatarSkinTone: string;
  saveAvatarHairColor: string;
  saveAvatarShirtColor: string;
  cardDetails: DocRequestDetails;
  profilePicture: string;
}

export const AddYourDocumentsCardProfileData = ({
  saveAvatarName,
  saveAvatarSkinTone,
  saveAvatarHairColor,
  saveAvatarShirtColor,
  cardDetails,
  profilePicture,
}: AddYourDocumentsCardType) => {
  const cardName = cardDetails.profileDetails
    ? `${cardDetails.profileDetails.first_name + ' '}${
        cardDetails.profileDetails.middle_name
          ? cardDetails.profileDetails.middle_name + ' '
          : ' '
      }${cardDetails.profileDetails.last_name}`
    : '';

  const profile = cardDetails.profileDetails?.dependent_profile;

  return (
    <AddYourDocumentsPaperStyled data-testid="add-documents-card-details">
      <AddYourDocumentsDependentBoxStyled>
        <DocumentRequestProfileStyled sx={{ marginRight: '1rem' }}>
          {profile?.avatar ? (
            <FamilyDrawerDisplayPicture
              saveAvatarName={saveAvatarName}
              saveAvatarSkinTone={saveAvatarSkinTone}
              saveAvatarHairColor={saveAvatarHairColor}
              saveAvatarShirtColor={saveAvatarShirtColor}
              size={35}
            />
          ) : profile?.profile_picture ? (
            <img src={profilePicture} alt="profile" />
          ) : (
            <DisplayNoAvatarIcon />
          )}
        </DocumentRequestProfileStyled>

        <Typography variant="body1" sx={{ fontWeight: 600 }}>
          {cardName}
        </Typography>
      </AddYourDocumentsDependentBoxStyled>
      {cardDetails.documentRequests.map((item, index) => {
        return (
          <>
            {index > 0 && <Divider />}
            {item.dependent_iq ? (
              <AddDependentIQCardDetails
                cardName={cardName}
                cardDetails={item}
                docTypes={cardDetails.documentTypes}
              />
            ) : item.status === 'requested' ? (
              <RequestedDocuments cardName={cardName} cardDetails={item} />
            ) : (
              <UploadedDocuments
                cardName={cardName}
                cardDetails={item}
                docTypes={cardDetails.documentTypes}
              />
            )}
          </>
        );
      })}
    </AddYourDocumentsPaperStyled>
  );
};
